import React, { useContext } from "react";
import { LayoutContext, constants } from "./LayoutContext";
import IconHome from "../assets/dazzle-home.svg";

export const TopbarHomeIcon = ({ i18n }) => {
  const layoutContext = useContext(LayoutContext);
  const { theme } = layoutContext;

  return (
    <div
      className={
        theme === constants.THEME_LIGHT
          ? "topbar-icon theme-light"
          : "topbar-icon theme-dark"
      }
      id="topbar-home-icon"
    >
      <a
        href={`/${
          i18n?.i18n_current === i18n?.i18n_main ? "" : i18n.i18n_current
        }`}
      >
        {/**ToDo (refactor): check whether it is i18n_main and set prefix by that  */}
        <IconHome className="topbar-svg-icon" />
      </a>
    </div>
  );
};
